// src/store/modules/categories.ts
import { client } from '@/lib/api';
import { preventError } from '@/utils/';
import { CategoryType, GetCategoriesInput, PagerInput, SearchInput } from '@/generated/graphql';
import { GET_CATEGORIES_FOR_MANAGEMENT_QUERY } from '@/graphql/category';

interface GetCategoriesPayload {
  categoryType: CategoryType;
  pager?: PagerInput;
  search?: SearchInput;
  freezeCache?: boolean;
}

export default {
  namespaced: true,

  // ---------------- STATE ----------------
  state: () => ({
    categories: [],
    categoriesPageInfo: {},
    refreshCategories: false,
  }),

  // ---------------- MUTATIONS ----------------
  mutations: {
    SET_CATEGORIES_LIST(state, val) {
      state.categories = val;
    },
    SET_CATEGORIES_PAGEINFO(state, val) {
      state.categoriesPageInfo = val;
    },
    SET_REFRESH_CATEGORIES(state, val) {
      state.refreshCategories = val;
    },
  },

  // ---------------- GETTERS ----------------
  getters: {
    categoriesList(state) {
      return state.categories.map((item) => ({
        id: item.id,
        name: item.name,
        description: item.description,
        categoryType: item.categoryType,
        procedureCount: item.procedureCount ?? 0,
        createdAt: item.createdAt,
      }));
    },
  },

  // ---------------- ACTIONS ----------------
  actions: {
    // === dispatch('categories/GET_CATEGORIES') ===
    async GET_CATEGORIES({ commit, rootGetters }, payload: GetCategoriesPayload) {
      const input: GetCategoriesInput = {
        institutionId: rootGetters.activeInstitutionId,
        categoryType: payload.categoryType,
        pager: payload.pager,
        search: payload.search,
      };

      try {
        const response = await client.query({
          query: GET_CATEGORIES_FOR_MANAGEMENT_QUERY,
          variables: { input },
          fetchPolicy: 'network-only',
        });

        if (!payload?.freezeCache) {
          commit('SET_CATEGORIES_LIST', response.data.getCategories.items);
          commit('SET_CATEGORIES_PAGEINFO', response.data.getCategories.pager);
          commit('SET_REFRESH_CATEGORIES', false);
        }

        return response.data.getCategories;
      } catch (e) {
        console.error('ERROR', e.message);
        preventError(e);
      }
    },
  },
};
